export default __webpack_public_path__ + "static-bigflip/media/loader-big-flip.4b1d3d31.lottie";